<template>
	<div>
		<b-badge variant="primary" class="cursor-pointer" @click="showPeriodsModal = true">
			<div v-if="padrillo.period_days != null">
				Periodo:
				<span>{{ padrillo.period_days }} días</span>
			</div>
			<div v-else>Ver periodos</div>
		</b-badge>
		<PeriodsByPadrilloModal v-if="showPeriodsModal" @close="showPeriodsModal = false" :padrilloId="padrillo.id" />
	</div>
</template>

<script>
import PeriodsByPadrilloModal from "@/components/specimens/posture-periods/PeriodsByPadrilloModal.vue"
export default {
	name: "PeriodDays",
	components: { PeriodsByPadrilloModal },
	props: {
		padrillo: {
			type: Object,
			required: true,
		},
	},
	created() {},
	computed: {},
	watch: {},
	data() {
		return {
			showPeriodsModal: false,
		}
	},
	methods: {},
}
</script>

<style lang="scss" scoped></style>
